import { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Row,
  Spinner
} from 'reactstrap';
import BreadCrumb from '../../../Components/Common/BreadCrumb';
import TableContainer from '../../../Components/Common/TableContainer';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { paramsForExport, setDocumentTitle } from '../../../helpers/helpers';
import { Pagination } from '../../../Components/Custom/pagination';

import { Filters } from './filters';

import { columns } from './columns';
import {
  getConversions,
  exportConvertedPackages,
  exportHeaders,
  removeUsersPackagesForExport
} from './slice';
import { PageHeader } from '../../../Components/Custom/PageHeader';
import { CsvExport } from '../../../Components/Custom/CsvExport';
import moment from 'moment';

const PAGE_TITLE = 'Conversions';

const ConversionsPage = () => {
  const INITIAL_PARAMS: {
    sortBy: string;
    sortOrder: string;
    countPerPage: string;
    numberOfPage: string;
  } = {
    sortBy: 'dateConverted',
    sortOrder: 'DESC',
    countPerPage: '10',
    numberOfPage: '1'
  };

  const [searchParams, setSearchParams] = useSearchParams(INITIAL_PARAMS);
  const dispatch = useAppDispatch();
  const { loading, data, loadingExport, dataForExport, totalCount } =
    useAppSelector((state) => state.conversions);

  useEffect(() => {
    dispatch(getConversions(searchParams));
  }, [searchParams]);

  setDocumentTitle(PAGE_TITLE);

  return (
    <div className='page-content'>
      <Container fluid>
        <BreadCrumb title={PAGE_TITLE} pageTitle='Dashboard' />
        <Row>
          <Col lg={12}>
            <Card id='orderList'>
              <PageHeader
                loading={loading}
                initialParams={INITIAL_PARAMS}
                setSearchParams={setSearchParams}
                title={PAGE_TITLE}
                actions={
                  <CsvExport
                    action={() =>
                      dispatch(
                        exportConvertedPackages(paramsForExport(searchParams))
                      )
                    }
                    data={dataForExport}
                    headers={exportHeaders}
                    disabled={loadingExport}
                    fileName={`userPackages-${moment().format('DD-MM-YYYY')}`}
                    removeDataAction={removeUsersPackagesForExport}
                  />
                }
              />

              <CardBody className='pt-0'>
                <Filters params={searchParams} setParams={setSearchParams} />
                <TableContainer
                  columns={columns || []}
                  data={data}
                  divClass='table-responsive table-card mb-1'
                  tableClass='align-middle table-nowrap'
                  theadClass='table-light text-muted'
                />

                <Pagination
                  totalCount={totalCount}
                  data={data}
                  params={searchParams}
                  setParams={setSearchParams}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ConversionsPage;
